module.exports = __webpack_public_path__ + "static/media/mobile-img-2.e852568a.png";